import { colors } from "./colors";
import {
  primaryFonts,
  secondaryFonts,
  titleFonts,
  subTitleFonts,
} from "./fonts";

export const theme: Theme = {
  fonts: {
    title: titleFonts,
    subtitle: subTitleFonts,
    secondary: secondaryFonts,
    primary: primaryFonts,
  },
  colors,
};
